import React, { useMemo } from 'react';
import { ChainFilterForm } from './ChainFilterForm';
import { Scenario, TagType } from '@/types';
import { useDispatch, useSelector } from 'react-redux';
import {
  ChainFilters,
  scenarioActions,
  selectChainFilters,
  selectSortProperty,
  SortProperty,
} from '../scenarioSlice';
import { selectSortedTsps } from '../../map/slice/mapSelectors';
import * as pathActions from '../../paths/pathsSlice';
import { EyeIcon, EyeOffIcon } from '@iconicicons/react';

export type OptimizationChainOptionsProps = {
  scenario: Scenario;
};

export const OptimizationChainOptions: React.FC<
  OptimizationChainOptionsProps
> = ({ scenario }) => {
  const dispatch = useDispatch();
  const chainFilters = useSelector(selectChainFilters);
  const tsps = useSelector(selectSortedTsps);

  const sortBy = useSelector(selectSortProperty);
  const setSortBy = (property: SortProperty) => {
    dispatch(scenarioActions.setSortProperty({ sortBy: property }));
  };

  const hideAllChains = () => {
    dispatch(pathActions.hideAll(undefined));
  };

  const showAllChains = () => {
    dispatch(pathActions.showAll(undefined));
  };

  const chainTags = useMemo(() => {
    if (!scenario) return [];
    return scenario.operation_chains.reduce<TagType[]>((tags, chain) => {
      chain.chain_info.tags.forEach((tag) => {
        if (tags.some((t) => t.id === tag.type.id)) return;
        tags.push(tag.type);
      });
      return tags;
    }, []);
  }, [scenario]);

  const setFilter = (
    type: keyof ChainFilters,
    setterFunc: (currentFilters: ChainFilters) => ChainFilters,
  ) => {
    const newFilters = setterFunc(chainFilters);
    dispatch(
      scenarioActions.setChainFilters({ type, value: newFilters[type] }),
    );
  };
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-4">
          <div className="btn-group" role="group">
            <button className="btn btn-outline-primary" onClick={hideAllChains}>
              Hide All <EyeOffIcon />
            </button>
            <button
              type="button"
              className="btn btn-outline-primary"
              onClick={showAllChains}
            >
              Show All <EyeIcon />
            </button>
          </div>
        </div>
        <div className="col-4">
          <ChainFilterForm
            filter={chainFilters}
            setFilter={setFilter}
            tsps={tsps}
            tags={chainTags}
          />
        </div>
        <div className="col">
          <div className="input-group mb-1">
            <label htmlFor="scenario-chain-filter" className="input-group-text">
              Sort By
            </label>
            <select
              id="scenario-chain-filter"
              className="form-select"
              value={sortBy}
              onChange={(evt) => setSortBy(evt.target.value as SortProperty)}
            >
              <option value="PROFIT">Profit</option>
              <option value="PROFIT_DTH">Profit/Dth</option>
              <option value="NAME">Name</option>
              <option value="IS_NEW">New chains first</option>
              <option value="VOLUME">Delivered volume</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};
